import styled, { css } from "styled-components";
import theme from "../../../Themes/light";

const { colors } = theme;

const commonStyles = css`
  width: 100rem;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .containerQuill {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    padding: 0rem 0 2rem 0;
  }

  .texto {
    color: ${(props) => props.theme.colors.tertiary};
    text-align: justify;
    margin-bottom: 3rem;
    width: 80%;
  }
`;

export const ContainerPoliticaDeFreteContainer = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      width: 100%;
      max-width: 100%;
      .texto {
        width: 100%;
        text-align: justify;
        padding: 5rem 0 2rem 0;
        margin: 0;
      }
      .containerQuill {
        width: 100%;
      }
    `}
`;
